document.addEventListener("DOMContentLoaded",()=>{

const current=document.querySelector(".sidebar-item.active");

if(current){

const submenu=current.querySelector(".sidebar-submenu");

if(submenu){

submenu.style.maxHeight=submenu.scrollHeight+"px";

}

}

// Desktop accordion

const items=document.querySelectorAll(".sidebar-item");

items.forEach(item=>{

const submenu=item.querySelector(".sidebar-submenu");

if(!submenu) return;

if(!item.classList.contains("active")){

submenu.style.maxHeight="0px";

}

});

// Mobile Drawer

const openBtn=document.querySelector(".open-sidebar");

const closeBtn=document.querySelector(".close-sidebar");

const drawer=document.querySelector(".mobile-sidebar");

const overlay=document.querySelector(".mobile-sidebar-overlay");

if(openBtn){

openBtn.onclick=function(){

drawer.classList.add("active");

overlay.classList.add("active");

document.body.style.overflow="hidden";

};

}

function closeDrawer(){

drawer.classList.remove("active");

overlay.classList.remove("active");

document.body.style.overflow="";

}

if(closeBtn){

closeBtn.onclick=closeDrawer;

}

if(overlay){

overlay.onclick=closeDrawer;

}

document.addEventListener("keydown",function(e){

if(e.key==="Escape"){

closeDrawer();

}

});

});